export const DateFormat = {
  DAY_LABEL: 'eeee',
  LONG: 'eeee, d MMMM yyyy',
  LONG_NO_YEAR: 'eeee, d MMMM',
  LONG_DAY: 'eeee d',
  MEDIUM: 'd MMMM yyyy',
  MEDIUM_COMPACT: 'd MMM yy',
  MEDIUM_DAY: 'eee d',
  SORT_DAY: 'eeeeee d',
  SHORT: 'dd/MM/yyyy',
  FILENAME_DATE: 'yyyyMMdd',

  DAY_MONTH: 'd MMM',
  YEAR_ONLY: 'yyyy',
  DAY_ONLY: 'dd',

  SHORT_DAY_NAME_ONLY: 'eeeeee',
  MONTH_NAME_ONLY: 'MMMM',
  MONTH_NAME_SHORT: 'MMM',
  MONTH_NAME_YEAR: 'MMMM yyyy',

  INPUT: 'yyyy-MM-dd',
  GQL: 'yyyy-MM-dd',
  ISO: 'yyyy-MM-dd',
  EXCEL: 'dd-MM-yyyy',
};

export const TimeFormat = {
  LONG: 'HH:mm',
  MEDIUM: 'HH:mm',
  SHORT: 'HH:mm',
  HOUR: `haaaaa'm'`,
  AMPM: 'bbb',
  FRIENDLY: 'HH:mm:ss',
  INPUT: 'HH:mm',
  GQL: 'HH:mm:ss.SSSXXX',
};

export const DateTimeFormat = {
  LONG: `${DateFormat.LONG} ${TimeFormat.LONG}`,
  MEDIUM: `${DateFormat.MEDIUM} ${TimeFormat.MEDIUM}`,
  SHORT: `${DateFormat.SHORT} ${TimeFormat.SHORT}`,
  MEDIUM_FRIENDLY: `${DateFormat.MEDIUM} ${TimeFormat.SHORT} ${TimeFormat.AMPM}`,
  LONG_FRIENDLY: `${DateFormat.LONG}' at '${TimeFormat.MEDIUM}' hrs'`,
  FRIENDLY: `${DateFormat.INPUT} ${TimeFormat.FRIENDLY}`,
  GQL: `${DateFormat.GQL}'T'${TimeFormat.GQL}`,
  INPUT: `${DateFormat.INPUT} ${TimeFormat.INPUT}`,
};
